import { getHost } from '@kk-activity-factory/utils';
import { globalInstance } from '@kk-activity-factory/utils';

const HOST = getHost();
export function getActivityDetail() {
    const url = HOST + '/gamecard/v2/activityEnginePage';
    let p;
    if (window.getActivityDetail) {
        p = window.getActivityDetail;
        window.getActivityDetail = null;
    } else {
        let data = {};
        if (typeof window.getQuery('preview') !== 'undefined') {
            data = {
                id: window.activityEnginePageID,
                preview: window.getQuery('preview'),
            };
        } else {
            data = {
                id: window.activityEnginePageID,
            };
        }
        p = request({
            url: url,
            data: data,
        });
    }
    return p;
}

// 拉取活动引擎入口信息，主要用于取活动名称（ActivityName）供投票模块曝光埋点使用
export function activityEngineEntry(id) {
    const url = HOST + '/gamecard/v2/activityEngine/entry';
    return request({
        url: url,
        data: {
            id,
        },
    });
}

export function visitInfo() {
    const url = HOST + '/gamecard/v2/activityEnginePage/visitInfo';
    console.info(`请求${url}`);
    return request({
        url: url,
        data: {
            id: globalInstance.getRootStore().state.pageData.id,
        },
    });
}
